<template>
  <vx-table :columns="columns" :resource="resource" :filters="filters" />
</template>

<script>
import { balanceChanges, passDataToResource, balanceChangeReasonTypes } from '@/services/resources'
import { buildRoute, path } from '@/router'
import { filterTypes, sortOrders } from '@/services/table'
import { VxCellDate, VxCellLink, VxCellMoney, VxCellPlayerAvatar, VxTable } from '@/components/table'
import { buildMoney } from '@/services/utils'

export default {
  name: 'BalanceChanges',
  components: {
    VxTable,
    VxCellPlayerAvatar,
    VxCellLink,
    VxCellMoney,
    VxCellDate
  },
  setup () {
    const resource = passDataToResource(balanceChanges.getAll, {
      requestParams: {
        params: { include: 'account.player,reason' }
      }
    })

    const reasonTypeLinks = {
      [balanceChangeReasonTypes.exchange]: path.exchanges,
      [balanceChangeReasonTypes.chestOpening]: path.caseOpens,
      [balanceChangeReasonTypes.user]: path.admins,
      [balanceChangeReasonTypes.balanceChangeRequest]: path.balanceChangeRequests,
      [balanceChangeReasonTypes.drop]: path.drops,
      [balanceChangeReasonTypes.payment]: path.payments,
      [balanceChangeReasonTypes.bonusPlayer]: path.bonusUsages
    }

    const getReasonId = ({ reason_id, reason_type, reason = {} }) => {
      switch (reason_type) {
        case balanceChangeReasonTypes.bonusPlayer:
          return reason?.bonus_player_id
        default:
          return reason_id
      }
    }

    const getReasonTypeRoute = (reasonType, id) => {
      const route = reasonTypeLinks[reasonType]
      return route && buildRoute(route, { query: { id } })
    }

    const columns = [
      {
        key: 'id',
        sortable: true,
        defaultSort: sortOrders.desc
      },
      {
        key: 'account.player',
        label: 'Player',
        component: VxCellPlayerAvatar
      },
      {
        key: 'delta',
        component: VxCellMoney,
        tdAttr: (delta, key, item) => ({
          money: buildMoney(delta, item?.account?.currency_code)
        })
      },
      {
        key: 'main_delta',
        component: VxCellMoney,
        tdAttr: (mainDelta, key, item) => ({
          money: buildMoney(mainDelta, item?.account?.currency_code)
        })
      },
      {
        key: 'old_balance',
        component: VxCellMoney,
        tdAttr: (oldBalance, key, item) => ({
          money: buildMoney(oldBalance, item?.account?.currency_code)
        })
      },
      {
        key: 'account.balance',
        label: 'Balance',
        component: VxCellMoney
      },
      {
        key: 'reason_type',
        label: 'Reason',
        component: VxCellLink,
        tdAttr: (reasonType, key, item) => {
          const id = getReasonId(item)
          return {
            label: reasonType,
            subLabel: `#${id}`,
            href: getReasonTypeRoute(reasonType, id),
            showLabelWithoutHref: true
          }
        }
      },
      {
        key: 'created_at',
        label: 'Date of change',
        component: VxCellDate,
        tdAttr: { showTime: true }
      }
    ]

    const filters = [
      {
        key: 'id',
        type: filterTypes.number
      },
      {
        key: 'player_id',
        type: filterTypes.number
      },
      {
        key: 'reason_id',
        type: filterTypes.number
      },
      {
        key: 'reason_type',
        type: filterTypes.serverSelect,
        resourceMapper: ({ types }) => types,
        resource: balanceChanges.reasonTypes,
        searchable: false
      },
      {
        key: 'date_of_change',
        type: filterTypes.dateRangePicker,
        apiKeys: ['from', 'to']
      }
    ]

    return {
      resource,
      columns,
      filters
    }
  }
}
</script>
